OpMultiSelector<template>
    <div class="form-field op-multi-selector">
        <div class="title" v-if="label">{{ label }}</div>
        <div class="restrict" v-if="required">
            <div
                v-if="required"
                :class="[
                    'restrict-item',
                    checkRequired ? 'checked-ok' : 'checked-error'
                ]"
            >
                必
            </div>
        </div>
        <div class="items">
            <span v-for="(item, ix) in list" :key="ix" :class="['op-checkbox']">
                <input
                    type="checkbox"
                    :value="getItemKey(item)"
                    @change="inputChange"
                    v-model="dataModel"
                    :name="name"
                    :id="myid + '_' + ix"
                />
                <label :for="myid + '_' + ix">
                    <slot :item="item">{{ getItemIndicate(item) }}</slot>
                </label>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "OpMultiSelector",
    model: {
        prop: "arrayModel",
        event: "input"
    },
    props: {
        arrayModel: Array,
        list: Array,
        name: String,
        required: Boolean,
        label: String,
        disabled: Boolean,
        readonly: Boolean,
        itemKey: Function,
        itemIndicate: Function
    },
    data: function() {
        return {
            dataModel: this.sanitizeModel(this.arrayModel),
            validflag: false,
            myid: ""
        };
    },
    methods: {
        sanitizeModel: function(ary) {
            let ret = [];
            if (ary) {
                for (const v of ary) {
                    // for (const div in this.list) {
                    //     if (v == div) {
                    ret.push(v);
                    // }
                    // }
                }
            }
            return ret;
        },
        inputChange: function() {
            console.log("★ this.$emit " + this.dataModel);
            this.$emit("input", this.dataModel);
        },
        _checkRequired() {
            let ret = !this.required || this.dataModel != null;
            this.validflag = ret;
            return ret;
        },
        getItemKey: function(item) {
            if (this.itemKey) {
                return this.itemKey(item);
            }
            return item;
        },
        getItemIndicate: function(item) {
            if (this.itemIndicate) {
                return this.itemIndicate(item);
            }
            return item;
        }
    },
    watch: {
        validflag: function(value) {
            if (this.name) {
                this.$emit("changed-valid", this.name, value);
            }
        },
        arrayModel: function(val) {
            this.dataModel = this.sanitizeModel(val);
        }
    },
    computed: {
        checkRequired() {
            return this._checkRequired();
        }
    },
    mounted: function() {
        this._checkRequired();
        this.$emit("changed-valid", this.name, this.validflag);
    },
    created: function() {
        if (!this.myid) {
            this.$store.commit("inclementIdseq");
            this.myid = "oppo2020" + this.$store.state.idseq;
        }
    }
};
</script>
